import * as React from 'react';
import type { ControlPlaneClientManager } from '../clients/ControlPlaneClientManager';
import { PermissionClaim } from '../code-generated/PermissionClaim.generated';

export type ControlPlanePermissionClaim =
  | PermissionClaim.CustomerOnboardingValidation
  | PermissionClaim.CustomerOnboardingMutating;

export interface ControlPlaneClientManagerContextValue {
  legacy: ControlPlaneClientManager | null;
  [PermissionClaim.CustomerOnboardingValidation]: ControlPlaneClientManager | null;
  [PermissionClaim.CustomerOnboardingMutating]: ControlPlaneClientManager | null;
}

export const ControlPlaneClientManagerContext = React.createContext<ControlPlaneClientManagerContextValue>({
  legacy: null,
  [PermissionClaim.CustomerOnboardingValidation]: null,
  [PermissionClaim.CustomerOnboardingMutating]: null,
});

export function useControlPlaneClientManager(
  permission?: ControlPlanePermissionClaim,
): ControlPlaneClientManager | null {
  const clients = React.useContext(ControlPlaneClientManagerContext);
  if (permission === undefined) return clients.legacy;
  return clients[permission];
}
